// Spinner.js
import React from 'react';
import '../styles/Spinner.css'; // Path to your Spinner CSS

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
